var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2946 3.03329C12.2971 3.18957 12.3452 3.34172 12.433 3.47101C12.5208 3.60031 12.6445 3.70111 12.7889 3.761C14.0795 4.32885 15.1709 5.26948 15.923 6.4621C16.675 7.65473 17.0535 9.04493 17.0098 10.4542C16.9794 12.33 16.205 14.1169 14.8571 15.4218C13.5092 16.7267 11.6981 17.4427 9.82226 17.4123C7.94644 17.3818 6.15954 16.6075 4.85465 15.2596C3.54976 13.9116 2.83378 12.1006 2.86421 10.2247C2.86602 8.85437 3.2659 7.51404 4.01522 6.36668C4.76455 5.21932 5.83106 4.31435 7.08509 3.76179C7.22952 3.70153 7.35323 3.60043 7.44104 3.47089C7.52884 3.34134 7.57693 3.18898 7.5794 3.0325C7.5796 2.90379 7.54818 2.77699 7.48791 2.66326C7.42763 2.54953 7.34034 2.45234 7.23371 2.38025C7.12708 2.30815 7.00437 2.26335 6.87637 2.24978C6.74837 2.23621 6.619 2.25429 6.49962 2.30243C4.67585 3.09313 3.1803 4.4882 2.26488 6.25266C1.34945 8.01713 1.0701 10.0432 1.47386 11.9895C1.87762 13.9359 2.93983 15.6836 4.48157 16.9384C6.02331 18.1931 7.95038 18.8782 9.93818 18.8782C11.926 18.8782 13.853 18.1931 15.3948 16.9384C16.9365 15.6836 17.9987 13.9359 18.4025 11.9895C18.8063 10.0432 18.5269 8.01713 17.6115 6.25266C16.6961 4.4882 15.2005 3.09313 13.3767 2.30243C13.2572 2.25377 13.1275 2.2353 12.9991 2.24867C12.8707 2.26203 12.7476 2.30682 12.6406 2.37906C12.5336 2.45131 12.4461 2.54879 12.3858 2.66289C12.3254 2.777 12.2941 2.90421 12.2946 3.03329Z",
    fill: "#F76D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7229 0.79435C10.7229 0.360328 10.3711 0.00848389 9.93705 0.00848389C9.50303 0.00848389 9.15118 0.360328 9.15118 0.79435V5.50954C9.15118 5.94357 9.50303 6.29541 9.93705 6.29541C10.3711 6.29541 10.7229 5.94357 10.7229 5.50954V0.79435Z",
    fill: "#F76D6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8608,
    height: 18.8608,
    fill: "white",
    transform: "translate(0.506653 0.00854492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0a3076838db5354829f594baf76d76b9.svg";
export { ForwardRef as ReactComponent };